import { FC, Fragment } from 'react';

// Third-party
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';

// Types
import { MemoizedBaseAvatar } from '@mgm/common/components/base';
import { TSubmissionNotes } from '../type';

// Components

const SubmissionNotes: FC<TSubmissionNotes> = ({ notes }) => (
  <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
    {notes.map((note) => (
      <Fragment key={note.email}>
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <MemoizedBaseAvatar avatarName={note.name} avatarFile={note.avatarFile} />
          </ListItemAvatar>
          <ListItemText
            primary={note.name}
            secondary={note?.note || ''}
          />
        </ListItem>
        <Divider
          sx={{
            borderStyle: 'dashed',
          }}
          variant="inset"
          component="li"
        />
      </Fragment>
    ))}
  </List>
);

export {
  SubmissionNotes,
};
